import * as ReactHabitat from 'react-habitat';
import AppWidget from '../widgets/AppWidget';
import IBESearchWidget from '../widgets/IBESearchWidget';
import { CustomHabitatFactory } from './CustomHabitatFactory';
import DealFinderWidget from '../widgets/DealFinderWidget';

class Habitat extends ReactHabitat.Bootstrapper {
  constructor() {
    super();

    const builder = new ReactHabitat.ContainerBuilder();
    builder.factory = new CustomHabitatFactory();
    builder.register(AppWidget).as('IBEFrontend');
    builder.register(IBESearchWidget).as('IBESearchWidget');
    builder.register(DealFinderWidget).as('IBEDealFinder');
    this.setContainer(builder.build());
  }
}

export default new Habitat();
